export function normalizeGeneratedAsset(rawUrl) {
  if (typeof rawUrl !== 'string' || !rawUrl) {
    return rawUrl;
  }

  if (rawUrl.match(/\.(mp4|webm|mov|avi)/i)) {
    return {
      url: rawUrl,
      isVideo: true,
      filename: 'botgo-video.mp4',
    };
  }

  if (rawUrl.includes('filesystem.site/cdn/') && !rawUrl.match(/\.(jpg|jpeg|png|gif|webp)$/i)) {
    return {
      url: rawUrl,
      isImage: true,
      filename: 'botgo-image.jpg',
    };
  }

  return rawUrl;
}
